<template>
  <nav>
    <v-app-bar color="#4DBA87" text app>
      <v-app-bar-nav-icon @click="drawer = !drawer" color="white"></v-app-bar-nav-icon>
      <v-toolbar-title class="navBarText">
        <span class="navBarText">Fire Watch 101</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text class="navBarText" @click="logout()">
        <span class="navBarText">Log Out</span>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer app v-model="drawer">
      <center>
        <h1>Fire Watch 101</h1>
      </center>
      <div>
        <h3 id="usernameLabel" class="userDetails">{{username}}</h3>
        <h3 id="userDescriptionLabel" class="userDetails">{{userDescription}}</h3>
      </div>
      <router-link v-if="!paid_user" to="/goPremium" class="subheading mx-3">Go Premium!</router-link>
      <v-divider></v-divider>
      <v-list nav>
        <v-list-item @click="navigate(item.url)" v-for="item in listItems" :key="item.title" link>
          <v-list-item-icon>
            <v-icon> {{item.icon}} </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{item.title}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-dialog v-model="departmentMessageBoxOpen" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
           {{departmentMessageTitle}}
          </v-card-title>
  
          <v-card-text>
            <pre>{{departmentMessageText}}</pre>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="departmentMessageBoxOpen = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </nav>
</template>

<script>
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { initializeApp } from "firebase/app";
export default {
  data() {
    return {
      drawer: false,
      departmentMessageBoxOpen: false,
      departmentMessageTitle: null,
      departmentMessageText: null,
      group: null,
      username: null,
      paid_user: false,
      userDescription: null,
      listItems: [
        {title: 'Watchlist', icon: 'mdi-view-dashboard-outline', url: "/watchlist"},
        {title: 'All Incidents', icon: 'mdi-fire-truck', url: "/all-incidents-search"},
        {title: 'Watchlist Settings', icon: 'mdi-cog-outline', url: "/watchlist-settings"},
        {title: 'My Account', icon: 'mdi-contacts-outline', url: "/account"},
        {title: 'Contact Us', icon: 'mdi-human-greeting-proximity', url: "/contact"}
      ]
    }
  },
  async created(){
  this.getAppSettings();
  if (Notification.permission == "granted"){
    this.firebaseMessagingInit();
  }

  },
  methods: {
    navigate(url){
      this.$router.push(url);
    },
    logout(){
      if(confirm("Are you sure you want to log out?")){
        localStorage.removeItem('username');
        localStorage.removeItem('token');
        location.reload();
      }
    },
  async getAppSettings(){
  const settingsResponse = await fetch(localStorage.apiURL+"/app/settings",{
      method: "GET",
      headers: {"deviceID": localStorage.token, "tokenID": localStorage.tokenID},
    });
    const settingsData = await settingsResponse.json();
      if (!settingsResponse.ok){
        if (settingsResponse.status == 401){
          localStorage.removeItem('username');
          localStorage.removeItem('token');
          alert("This device has been logged out.");
          location.reload();
        }
        this.error("api returned " + settingsResponse.status);
        return
      }
    if (settingsData.success){
      localStorage.areaID = settingsData.county_id;
      localStorage.username = settingsData.username;
      localStorage.areaName = settingsData.county_name;
      localStorage.paid_user = settingsData.paid_user;
      localStorage.allow_text = settingsData.allow_text
      if (settingsData.alertForUser){
        alert(settingsData.alertForUserTitle + "\n\n" + settingsData.alertForUserBody);
      }
    } else {
      this.error("an error occured " + settingsData.msg)
      return
    }
    if (localStorage.paid_user == 'true'){
      this.paid_user = true;
      this.userDescription = "-Premium User"
    } else {
      this.userDescription = "-Free User"
    }
    this.username = localStorage.username;
  },
  firebaseMessagingInit(){
   const firebaseConfig = {
        apiKey: "AIzaSyBHoKJaMLXFnsHFXMcEJGXTCtxg6adbOWo",
        authDomain: "firewatch101-1578706515856.firebaseapp.com",
        databaseURL: "https://firewatch101-1578706515856.firebaseio.com",
        projectId: "firewatch101-1578706515856",
        storageBucket: "firewatch101-1578706515856.appspot.com",
        messagingSenderId: "308197360371",
        appId: "1:308197360371:web:2c22f4a09f768891bbad86",
        measurementId: "G-LPF5P9J6SX"
    };

    initializeApp(firebaseConfig);
    const messaging = getMessaging();

      getToken(messaging, { vapidKey: "BDa_M_mDDnuZCUTqHwht-n5LkqG4p047hQ696lTJyWYdpgSdreokjq0Gm4jGvjp2dGR-2oCMrar3tsRqlciO5vU" })
      .then(async function(currentToken){
        if (currentToken) {
          const response = await fetch(localStorage.apiURL + "/app/tokenUpdate", {
              method: "POST",
              headers: {"Content-Type": "application/json", "deviceID": localStorage.token, "tokenID": localStorage.tokenID},
              body: JSON.stringify({
                newToken: currentToken
              })
            });

          if (!response.ok){
            this.error("API returned " + response.status);
            return
          }
        }
      }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      })
      onMessage(messaging, (payload) => {
        const viewNotification = confirm("New incident notification recieved. Do you want to view?")

        if (viewNotification){
          if (payload.notification.incidentID != undefined){
            this.$router.push({path: 'incident', query: { incident: payload.data.incidentID }});
          } else {
            this.departmentMessageTitle = payload.notification.title;
            this.departmentMessageText = payload.notification.body;
            console.log(this.departmentMessageText);
            this.departmentMessageBoxOpen = true;
          }
        }
      });
    },
  }
}
</script>

<style>
#username{
  margin-top: 500px;
}
.userDetails{
  margin-left: 7px;
  font-weight: bold;
}

.navBarText{
  color: white;

}
</style>